import React from "react";

export interface FunnelItemProps {
    color: string;
    heading: string;
    count: number;
    conversion?: number;
    maxCount: number;
    template?: string;
}

const FunnelDataBlock = (props: FunnelItemProps) => {
    const { template, heading, count, conversion, color } = props;
    const widthPercent = (props.count / props.maxCount) * 100;

     return(
        <div className={`funnelItemBlock columnCenter${template === "column" ? " column" : ""}`} style={
            template === "column" ? 
              { background: color, height: `${widthPercent}%`, justifyContent: "end" }
            : { background: color, width: `${Math.min(widthPercent, 99)}%` }
            }>
            <div className="funnelItemData" style={template === "column" ? { marginBottom: 12}: {}}>
               <div className="funnelItemHeading">{`${template === "column" ? heading : `${heading}: ${count}`}`}</div>
               {template === "column" && <div className="funnelItemText">Всего: {count}</div>}
               {template === "column" && conversion && <div className="funnelItemText">Конверсия: {`${conversion}%`}</div>}
            </div>
        </div>
     )
}

export default FunnelDataBlock;